var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.getClass,attrs:{"disabled":_vm.isDiasable},on:{"click":_vm.action}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }